<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/add/black</title>
    <g id="atoms/icons/24x24/add/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M12,2 C12.4418278,2 12.8,2.3581722 12.8,2.8 L12.799,11.2 L21.2,11.2 C21.6418278,11.2 22,11.5581722 22,12 C22,12.4418278 21.6418278,12.8 21.2,12.8 L12.799,12.8 L12.8,21.2 C12.8,21.6418278 12.4418278,22 12,22 C11.5581722,22 11.2,21.6418278 11.2,21.2 L11.199,12.8 L2.8,12.8 C2.3581722,12.8 2,12.4418278 2,12 C2,11.5581722 2.3581722,11.2 2.8,11.2 L11.199,11.2 L11.2,2.8 C11.2,2.3581722 11.5581722,2 12,2 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
